import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["alert"]

  connect() {
    this.startTimeout()
  }

  startTimeout() {
    this.clearTimeouts()
    this.timeout = setTimeout(() => this.hide(), 5000)
    this.removeTimeout = setTimeout(() => this.remove(), 10000)
  }

  clearTimeouts() {
    clearTimeout(this.timeout)
    clearTimeout(this.removeTimeout)
  }

  hide() {
    this.alertTarget.classList.add("hidden")
  }

  remove() {
    this.element.remove()
  }

  close() {
    this.clearTimeouts()
    this.hide()
  }

  pauseTimeout() {
    this.clearTimeouts() // Stop the hide timeout when hovering
  }

  resumeTimeout() {
    this.startTimeout() // Restart the hide timeout when leaving
  }
}
